/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";

/*
 * @Description: 表单验证
 */
import Vue from "vue";
import VeeValidate, { Validator } from "vee-validate";
import RegExp from './regExp.js'; // 自定义validate

var config = {
  fieldsBagName: 'fieldBags',
  errorBagName: "veeErrors",
  // 所有的错误信息都是放在这个里面的
  locale: "zh_CN",
  // 验证消息的默认语言
  dictionary: {
    zh_CN: {
      messages: {
        // 自定义提示文字
        required: function required(field) {
          return field; // data-vv-as中的内容
        }
      },
      attributes: {}
    }
  }
};
Vue.use(VeeValidate, config);
Validator.extend("mobile", {
  getMessage: function getMessage(field) {
    return "\u7535\u8BDD\u683C\u5F0F\u4E0D\u6B63\u786E";
  },
  validate: function validate(value) {
    return RegExp.phone_simple.rule.test(value) && /^[0-9]*$/.test(value);
  }
});
Validator.extend("IDCard", {
  getMessage: function getMessage(field) {
    return "\u8BF7\u8F93\u5165\u6B63\u786E\u7684\u8EAB\u4EFD\u8BC1\u53F7";
  },
  validate: function validate(value) {
    return RegExp.IdCard.rule.test(value) && /^[0-9]*$/.test(value);
  }
});
Validator.extend("name", {
  getMessage: function getMessage(field) {
    return " ";
  },
  validate: function validate(value) {
    return RegExp.nameNE.rule.test(value) && !/^[0-9]*$/.test(value);
  }
});
Validator.extend("code", {
  getMessage: function getMessage(field) {
    return " ";
  },
  validate: function validate(value) {
    return /^[0-9]*$/.test(value) && /^\d{4}$/.test(value);
  }
});
Validator.extend("license", {
  getMessage: function getMessage(field) {
    return " ";
  },
  validate: function validate(value) {
    return RegExp.license.rule.test(value);
  }
});